// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"40c3826c","513":"74172695","703":"94ac40a6"}[chunkId] + ".chunk.js";
};